import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/commerce-pwa-studio/commerce-pwa-studio/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const CodeBlock = makeShortcode("CodeBlock");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "scaffolding"
    }}>{`Scaffolding`}</h1>
    <p>{`Project scaffolding is a technique for auto-generating required files to support a specific project structure.
PWA Studio provides a scaffolding tool to simplify project creation and help developers get started.`}</p>
    <h2 {...{
      "id": "default-project-template"
    }}>{`Default project template`}</h2>
    <p>{`The scaffolding tool uses the `}<inlineCode parentName="p">{`venia-concept`}</inlineCode>{` package as the default template for all new PWA Studio storefront projects.
When you `}<a parentName="p" {...{
        "href": "/commerce/pwa-studio/tutorials/setup-storefront/"
      }}>{`set up a new project`}</a>{`, the result is a project structure based on the files in this package.`}</p>
    <p>{`Most of its UI and logic come from its `}<inlineCode parentName="p">{`@magento/venia-ui`}</inlineCode>{` and `}<inlineCode parentName="p">{`@magento/peregrine`}</inlineCode>{` dependencies, so
it has very little code in its own project folder.`}</p>
    <p>{`Customizing these projects is as simple as importing small pieces of `}<inlineCode parentName="p">{`venia-ui`}</inlineCode>{` and combining them with custom code.`}</p>
    <p>{`For more information about the project template, see `}<a parentName="p" {...{
        "href": "/commerce/pwa-studio/guides/packages/buildpack/project-templates/"
      }}>{`Project Templates`}</a>{`.`}</p>
    <h2 {...{
      "id": "scaffolding-commands"
    }}>{`Scaffolding commands`}</h2>
    <p>{`When you `}<a parentName="p" {...{
        "href": "/commerce/pwa-studio/tutorials/setup-storefront/"
      }}>{`set up a new project`}</a>{` you use the `}<inlineCode parentName="p">{`@magento/create-pwa`}</inlineCode>{` package.
It is a simpler interface than the `}<a parentName="p" {...{
        "href": "/commerce/pwa-studio/api/buildpack/cli/create-project/"
      }}>{`create-project`}</a>{` sub-command in the `}<a parentName="p" {...{
        "href": "/commerce/pwa-studio/api/buildpack/cli/"
      }}>{`pwa-buildpack`}</a>{` CLI tool.`}</p>
    <p>{`Since the package name begins with `}<inlineCode parentName="p">{`create-`}</inlineCode>{`, it is considered a project generator and can be run simply as `}<inlineCode parentName="p">{`@magento/pwa`}</inlineCode>{`.
This command launches an interactive questionnaire in the command line for configuring different parts of the project.`}</p>
    <h3 {...{
      "id": "examples"
    }}>{`Examples`}</h3>
    <CodeBlock slots="heading, code" repeat="2" languages="sh, sh" mdxType="CodeBlock" />
    <h4 {...{
      "id": "yarn-command"
    }}>{`Yarn command`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-sh"
      }}>{`yarn create @magento/pwa
`}</code></pre>
    <h4 {...{
      "id": "npm-command"
    }}>{`NPM command`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-sh"
      }}>{`npm init @magento/pwa
`}</code></pre>
    <h2 {...{
      "id": "scaffolding-with-other-versions-of-pwa-studio"
    }}>{`Scaffolding with other versions of PWA Studio`}</h2>
    <p>{`To create scaffolding for a project using an older version of PWA Studio, the required version is noted in the `}<inlineCode parentName="p">{`create-`}</inlineCode>{` command.`}</p>
    <h3 {...{
      "id": "yarn-command-1"
    }}>{`YARN command`}</h3>
    <p><inlineCode parentName="p">{`yarn global add @magento/create-pwa@1.3.1`}</inlineCode></p>
    <p>{`and then:`}</p>
    <p><inlineCode parentName="p">{`create-pwa`}</inlineCode></p>
    <h3 {...{
      "id": "npm-command-1"
    }}>{`NPM command`}</h3>
    <p><inlineCode parentName="p">{`npm init @magento/pwa@1.3.1`}</inlineCode></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      